import { ReactNode } from "react";
import { StyledButton } from "./style";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  className: string;
  type?: "button" | "submit" | "reset" | undefined;
  emphasis?: boolean;
  small?: boolean;
}

const Button = ({
  children,
  className,
  type,
  emphasis = false,
  small = false,
  ...rest
}: IButton) => {
  return (
    <StyledButton
      className={className}
      emphasis={emphasis}
      small={small}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
